import type { ReactNode } from 'react';
import * as s from './EmptyState.css';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function EmptyState({
  icon = '📂',
  title: titleText,
  description: descText,
  action,
  size = 'md',
  className,
}: EmptyStateProps) {
  const cls = className
    ? `${s.containerRecipe({ size })} ${className}`
    : s.containerRecipe({ size });
  return (
    <div className={cls} role="status" aria-live="polite">
      <div className={s.iconWrapper} aria-hidden="true">
        {icon}
      </div>
      <p className={s.title}>{titleText}</p>
      {descText && <p className={s.description}>{descText}</p>}
      {action && <div className={s.actionWrapper}>{action}</div>}
    </div>
  );
}
